import { render } from "./EditProfilePage.vue?vue&type=template&id=bbe1e662&ts=true"
import script from "./EditProfilePage.vue?vue&type=script&lang=ts"
export * from "./EditProfilePage.vue?vue&type=script&lang=ts"

import "./EditProfilePage.vue?vue&type=style&index=0&id=bbe1e662&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__